import { render } from "./CompanyOnboarding.vue?vue&type=template&id=ac64a3e4&scoped=true"
import script from "./CompanyOnboarding.vue?vue&type=script&lang=js"
export * from "./CompanyOnboarding.vue?vue&type=script&lang=js"

import "./CompanyOnboarding.vue?vue&type=style&index=0&id=ac64a3e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac64a3e4"]])

export default __exports__